export default class MotifData {
  motifId;
  motifName;
  motifUrl;
  motifTags;
  motifWidth;
  motifHeight;
  motifType;
  motifImageData;
    motifFont;
    motifFontSize;
  motifFlossId;

  constructor(jsonData) {
    Object.assign(this, jsonData);
  }

  static clone(em) {
    let cm = new this();

    cm.motifId = em.motifId;
    cm.motifName = em.motifName;
    cm.motifUrl = em.motifUrl;
    cm.motifTags = em.motifTags;
    cm.motifWidth = em.motifWidth;
    cm.motifHeight = em.motifHeight;
    cm.motifType = em.motifType;
    cm.motifImageData = em.motifImageData;
    cm.motifFont = em.motifFont;
    cm.motifFlossId = em.motifFlossId;
      cm.motifFontSize = em.motifFontSize;
    return cm;
  }

  hasTwoLines() {
    return this.motifType == 3 || this.motifType == 4;
  }
}
